import { getUpdatedSubWorkspaceIds } from '@/modules/corporate/utils/subWorkspaces';
import { ArticleContentType, UpdateArticleInput } from '@/types/schema';

const getTransformedArticle = (
  article?: ArticleContentType | null,
  currentSubWorkspace?: string | null,
): UpdateArticleInput => {
  if (!article) {
    return {};
  }
  const updatedSubWorkspaceIds = getUpdatedSubWorkspaceIds(
    article?.subWorkspaces,
    currentSubWorkspace,
  );

  return {
    articleId: article.id,
    name: article.name,
    description: article.description,
    cover: article.cover ? { ...article.cover, mediaId: undefined } : null,
    mindsetIds: article.mindsetIds ? { set: article.mindsetIds } : undefined,
    goalIds: article.goalIds ? { set: article.goalIds } : undefined,
    skillIds: article.skillIds ? { set: article.skillIds } : undefined,
    duration: article.duration || 0,
    subWorkspaceIds: updatedSubWorkspaceIds,
  };
};

export default getTransformedArticle;
